import React from 'react';

/**
 * FirstStepsJourney - Welcome Disclaimer for new users
 * 
 * P2 UPDATE: Simplified to orient the user immediately after signup.
 * NOT a tutorial, NOT feature-heavy.
 * Purpose: "Come for calorie tracking, stay for intelligence."
 * 
 * Shows ONLY on first signup (controlled by localStorage in App.js)
 */
const FirstStepsJourney = ({ show, onClose, openCameraMode }) => {
  if (!show) return null;
  
  const handleLogFirstMeal = () => {
    onClose();
    openCameraMode('camera');
  };
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()} 
        style={{ maxWidth: '380px', textAlign: 'center' }}
      >
        {/* Welcome Header */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontSize: '44px', marginBottom: '10px' }}>🍽️</div>
          <h2 style={{ margin: '0 0 6px 0', fontSize: '20px', fontWeight: '700' }}>
            Welcome to SmartPlAIte
          </h2>
          <p style={{ 
            margin: 0, 
            fontSize: '14px', 
            color: 'var(--text-secondary)',
            lineHeight: '1.5'
          }}>
            Come for Calorie Tracking.<br/>
            <span style={{ color: '#667eea', fontWeight: '500' }}>Stay for Intelligence.</span>
          </p>
        </div>
        
        {/* Simple Bullet Points - What you need to know */}
        <div style={{ 
          textAlign: 'left', 
          marginBottom: '24px',
          padding: '16px',
          background: 'rgba(255,255,255,0.03)',
          borderRadius: '12px',
          border: '1px solid rgba(255,255,255,0.08)'
        }}>
          <ul style={{ 
            margin: 0, 
            padding: '0 0 0 20px',
            fontSize: '14px',
            color: 'var(--text-primary)',
            lineHeight: '2'
          }}>
            <li>Start with simple calorie tracking</li>
            <li>Intelligence builds gradually from your meals</li>
            <li>Nothing is required upfront</li>
          </ul>
        </div>
        
        {/* Single Primary CTA */}
        <button 
          onClick={handleLogFirstMeal}
          className="btn-primary"
          style={{ 
            width: '100%', 
            padding: '16px',
            fontSize: '16px',
            fontWeight: '600',
            background: 'linear-gradient(135deg, #4caf50 0%, #8bc34a 100%)',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)'
          }}
        >
          📸 Log Your First Meal
        </button>
        
        {/* Subtle skip link */}
        <p 
          onClick={onClose}
          style={{ 
            marginTop: '16px',
            marginBottom: 0,
            fontSize: '12px',
            color: 'var(--text-secondary)',
            cursor: 'pointer',
            opacity: 0.7
          }}
        >
          Skip for now
        </p>
      </div>
    </div>
  );
};

export default FirstStepsJourney;
